import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-028b7cc2")

_pushScopeId("data-v-028b7cc2")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Our Coaches")
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "text-light"
}
const _hoisted_5 = {
  key: 1,
  class: "text-dark"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          _createVNode(_component_navbar)
        ]),
        _: 1
      }),
      (_ctx.trainers.length > 0)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 0,
            fullscreen: true
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_ion_grid, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trainers, (trainer, index) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            size: "12",
                            "size-lg": "4",
                            "size-md": "4",
                            "size-sm": "12",
                            key: index
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_card, {
                                button: "",
                                onClick: ($event: any) => (_ctx.openTrainerVideos(trainer)),
                                class: "trainer-card",
                                style: {
									'background-image': 'url(' + trainer.imgURL + ')',
								}
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { color: "primary" }, {
                                    default: _withId(() => [
                                      _createVNode("strong", null, _toDisplayString(trainer.name), 1),
                                      _hoisted_3,
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(trainer.categories, (category, index) => {
                                        return (_openBlock(), _createBlock("span", { key: index }, [
                                          (_ctx.client.mode==="light")
                                            ? (_openBlock(), _createBlock("strong", _hoisted_4, _toDisplayString(category), 1))
                                            : (_openBlock(), _createBlock("strong", _hoisted_5, _toDisplayString(category), 1))
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "style"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_content, {
            key: 1,
            class: "ion-text-center"
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_spinner, {
                class: "spinner",
                name: "crescent"
              })
            ]),
            _: 1
          })),
      _createVNode(_component_bottombar)
    ]),
    _: 1
  }))
})